import ManageCookies from './ManageCookies';

export default ManageCookies;
